<div class="app-event-contacts">
    <mat-tab-group mat-align-tabs="center" (selectedTabChange)="tabClick($event)" mat-stretch-tabs="false" mat-align-tabs="center">
        <mat-tab label="My Contacts" class="mat-tab" >
            <div class="c-container">
                <div class="text-right search-container ">
                    <input type="text" class="s-box text-secondary bg-secondary" [(ngModel)]="searchContact" placeholder="Search users" 
                    [style.background-color]="settingsData?.event_bg_secondary_color +'!important'"
                    [style.color]="settingsData?.event_font_secondary_color + '!important'"
                    [style.--placeholder-color]="settingsData?.event_font_secondary_color">
                    <i class="fa fa-search s-icon text-white " [style.color]="settingsData?.event_font_secondary_color + '!important'"  aria-hidden="true"></i>
                </div>
                <div class="row contacts-area no-gutters">
                    <ng-container *ngIf="( updatedContactsList | filter : searchContact:'name') as CList">
                    <div class="col-12 col-md-6 col-lg-4" *ngFor="let contact of CList | filter: searchContact:'name'">
                        <div class="contact-box bg-secondary" [style.background-color]="settingsData?.event_bg_secondary_color +'!important'"
                        [style.color]="settingsData?.event_font_secondary_color + '!important'">
                            <div class=" row  chat-profile no-gutters ">
                                <div class="col-3 col-md-3 col-lg-3">
                                    <div class="image-box">
                                        <div class="roundIcon1 text-center"
                                            *ngIf="contact?.contact_details.profile_pic; else userName">
                                            <img class="roundUserImage1" width="100%" height="100%" src="{{contact?.contact_details.profile_pic}}">
                                        </div>
                                        <ng-template #userName>
                                            <span class="profile-image-container rounded-circle"
                                                [ngStyle]="{'color': contact?.contact_details.userColor }">
                                                <span class="text-uppercase image-name notranslate">
                                                    {{contact?.contact_details.shortName}}</span>
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6">
                                    <div class="data-div">
                                        <h6 class="profile-name text-secondary ellipsis mb-0 ">{{contact?.name}}
                                        </h6>
                                        <p class="email text-secondary mb-0 mt-1 ellipsis">
                                            {{contact?.contact_details?.email}}
                                        </p>
                                        <p class="contact text-secondary mb-0 mt-1 ellipsis">
                                            {{contact?.contact_details?.phone_number}}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3 col-md-3 col-lg-3 text-right">
                                    <div>
                                        <!-- <img [src]="assets_url + 'Live-Stream-assets/chat-hover.svg'" class="messege-icon" width="20" height="20"
                                            matTooltipPosition="above" matTooltip="Chat" (click)="goToPrivateChat(contact)"> -->
                                            <span class="messege-icon"
                                            matTooltipPosition="above" matTooltip="Chat" (click)="goToPrivateChat(contact)">
                                            <app-svg [icon]="'live-stream-chat-hover'" [color]="settingsData?.event_font_secondary_color"></app-svg>
                                            </span>
                                        <!-- <img src="assets/messege-icon.png" alt="" class="messege-icon"> -->
                                        <button mat-icon-button [matMenuTriggerFor]="menu" [disableRipple]="true" class="ml-10"
                                        [style.color]="settingsData?.event_font_secondary_color +'!important'">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu" backdropClass="custom-menu">
                                            <button mat-menu-item (click)="blockContact(contact)">
                                                <span>Block</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                    <!-- <p class="date mb-0">2d ago</p> -->


                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="CList.length == 0 && isDataLoaded" class="text-center w-100 p-20">No records found</div> 
                </ng-container>
                </div>
            </div>

        </mat-tab>
        <mat-tab label="Request  Received" class="mat-tab">
            <div class="c-container">
                <div class="text-right search-container ">
                    <input type="text" class="s-box text-secondary bg-secondary" [(ngModel)]="searchContact" placeholder="Search users"
                    [style.background-color]="settingsData?.event_bg_secondary_color +'!important'"
                    [style.color]="settingsData?.event_font_secondary_color + '!important'"
                    [style.--placeholder-color]="settingsData?.event_font_secondary_color">
                    <i class="fa fa-search s-icon text-white " [style.color]="settingsData?.event_font_secondary_color + '!important'"  aria-hidden="true"></i>
                </div>
                <div class="row contacts-area no-gutters">
                    <ng-container *ngIf="( receivedContactsList | filter : searchContact:'name') as RList">
                    <div class="col-12 col-md-6 col-lg-4" *ngFor="let rc of RList | filter: searchContact:'name'">
                        <div class="contact-box bg-secondary"  [style.background-color]="settingsData?.event_bg_secondary_color +'!important'"
                        [style.color]="settingsData?.event_font_secondary_color + '!important'">
                            <div class=" row  chat-profile no-gutters align-items-center">
                                <div class="col-3 col-md-3 col-lg-3">
                                    <div class="image-box">
                                        <div class="roundIcon1 text-center" *ngIf="rc?.profile_pic; else userName">
                                            <img class="roundUserImage1" width="100%" height="100%" src="{{rc?.profile_pic}}">
                                        </div>
                                        <ng-template #userName>
                                            <span class="profile-image-container rounded-circle"
                                                [ngStyle]="{'color': rc?.userColor }">
                                                <span class="text-uppercase image-name notranslate"> {{rc?.shortName}}</span>
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6">
                                    <div class="data-div">
                                        <h6 class="profile-name text-secondary ellipsis mb-0 ">{{rc?.name}}
                                        </h6>
                                    </div>
                                </div>
                                <div class="col-3 col-md-3 col-lg-3 text-right">
                                    <div class="icons-size">
                                        <!-- <img [src]="assets_url + 'accept.svg'" alt="" (click)="processContactRequest(rc,'accept')" matTooltipPosition="above"
                                        matTooltip="Accept" class="messege-icon"> -->
                                        <span (click)="processContactRequest(rc,'accept')" matTooltipPosition="above"
                                        matTooltip="Accept" class="messege-icon"><app-svg [icon]="'accept'"></app-svg></span>
                                        <!-- <img [src]="assets_url + 'reject.svg'" alt="" (click)="processContactRequest(rc,'reject')" matTooltipPosition="above"
                                        matTooltip="Reject" class="messege-icon ml-10"> -->
                                        <span (click)="processContactRequest(rc,'reject')" matTooltipPosition="above"
                                        matTooltip="Reject" class="messege-icon ml-10"><app-svg [icon]="'reject'"></app-svg></span>
                                    </div>
                                    <!-- <p class="date mb-0">2d ago</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="RList.length == 0 && isDataLoaded" class="text-center w-100 p-20">No records found</div> 
                </ng-container>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Request Sent" class="mat-tab">
            <div class="c-container">
                <div class="text-right search-container ">
                    <input type="text" class="s-box text-secondary bg-secondary" [(ngModel)]="searchContact" placeholder="Search users"
                    [style.background-color]="settingsData?.event_bg_secondary_color +'!important'"
                    [style.color]="settingsData?.event_font_secondary_color + '!important'"
                    [style.--placeholder-color]="settingsData?.event_font_secondary_color">
                    <i class="fa fa-search s-icon text-white " [style.color]="settingsData?.event_font_secondary_color + '!important'"  aria-hidden="true"></i>
                </div>
                <div class="row contacts-area no-gutters">
                    <ng-container *ngIf="( sentContactsList | filter : searchContact:'name') as SList">
                    <div class="col-12 col-md-6 col-lg-4" *ngFor="let sc of SList | filter: searchContact:'name'">
                        <div class="contact-box bg-secondary"  [style.background-color]="settingsData?.event_bg_secondary_color +'!important'"
                        [style.color]="settingsData?.event_font_secondary_color + '!important'">
                            <div class=" row  chat-profile no-gutters align-items-center">
                                <div class="col-3 col-md-3 col-lg-3">
                                    <div class="image-box">
                                        <div class="roundIcon1 text-center" *ngIf="sc?.profile_pic; else userName">
                                            <img class="roundUserImage1" width="100%" height="100%" src="{{sc?.profile_pic}}">
                                        </div>
                                        <ng-template #userName>
                                            <span class="profile-image-container rounded-circle"
                                                [ngStyle]="{'color': sc?.userColor }">
                                                <span class="text-uppercase image-name notranslate"> {{sc?.shortName}}</span>
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6">
                                    <div class="data-div">
                                        <h6 class="profile-name text-secondary ellipsis mb-0 ">{{sc?.name}}
                                        </h6>
                                    </div>
                                </div>
                                <div class="col-3 col-md-3 col-lg-3 text-right">
                                    <div>
                                        <!-- <img src="assets/accept.png" alt="" class="messege-icon">
                                        <img src="assets/reject.png" alt="" class="messege-icon ml-10"> -->
                                    </div>
                                    <!-- <p class="date mb-0">2d ago</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="SList.length == 0 && isDataLoaded" class="text-center w-100 p-20">No records found</div> 
                </ng-container>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>